import CTLNotificationBooleanCell from "application/components/CTLNotificationBooleanCell";
import DefaultCell from "application/components/DefaultCell";
import formControl from "globals/form-control";

const getUpdateColumns = () => {
  return [
    {
      Header: "Location",
      accessor: "location",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
      groupHeading: "Location",
    },
    {
      Header: "Category",
      accessor: "category",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      disabled: true,
      dataType: "string",
      Cell: ({ value }) => <DefaultCell value={value} />,
      width: 6,
      groupHeading: "Location",
    },
   
    {
      Header: "Level 0 Mail Id",
      accessor: "escalationLevel0MailId",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      width: 6,
    },
    {
      Header: "Level 0 Sms Number",
      accessor: "escalationLevel0SmsId",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      width: 6,
    },
    {
      Header: "Level 1 Duration",
      accessor: "escalationLevel1Duration",
      displayInList: false,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "integer",
      width: 6,
    },
    {
      Header: "Level 1 Mail Id",
      accessor: "escalationLevel1MailId",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      width: 6,
    },
    {
      Header: "Level1 Sms Number",
      accessor: "escalationLevel1SmsId",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      width: 6,
    },
    {
      Header: "Level 2 Duration",
      accessor: "escalationLevel2Duration",
      displayInList: false,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "integer",
      width: 6,
    },
    {
      Header: "Level 2 Mail Id",
      accessor: "escalationLevel2MailId",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      width: 6,
    },
    {
      Header: "Level2 Sms Number",
      accessor: "escalationLevel2SmsId",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      width: 6,
    },
    {
      Header: "Level 3 Duration",
      accessor: "escalationLevel3Duration",
      displayInList: false,
      allowInForm: false,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "integer",
      width: 6,
    },
    {
      Header: "Level 3 Mail Id",
      accessor: "escalationLevel3MailId",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      width: 6,
    },
    {
      Header: "Level3 Sms Number",
      accessor: "escalationLevel3SmsId",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      Cell: ({ value }) => <DefaultCell value={value} />,
      dataType: "string",
      width: 6,
    },
    {
      Header: "Disable Notification",
      accessor: "disableNotification",
      displayInList: true,
      allowInForm: true,
      allowFilter: false,
      Cell: ({ value }) => <CTLNotificationBooleanCell value={value} />,
      dataType: "boolean",
      controlType: "boolean",
      groupHeading: "Location Category Service",
      width: 6,
    },
  ];
};

export { getUpdateColumns };
